import { useSession } from 'next-auth/react';
import useSWR from 'swr';

import { acquireToken } from '../../auth/acquireToken';

/**
 * Used only by `MarketplaceForm`, which doesn't make any requests by itself,
 * but sets the correct token to be used by form components.
 *
 * If you need to make a request to an API, you probably want to use `useScopedAPI` instead.
 */
export const useScopedAPIToken = (scopeRequests: Array<string>) => {
	const { data: session } = useSession();
	const scopeKey = session ? scopeRequests.join(';') : null;
	const { data: token, error } = useSWR(scopeKey, acquireToken, {
		revalidateIfStale: true,
		revalidateOnReconnect: true,
		refreshInterval: 1800000,
	});

	return {
		token,
		isTokenLoading: !error && !token,
		isTokenError: error,
	};
};
